import { AppointmentService } from "@/common/api.service";
import { FETCH_APPOINTMENT_DATA, FETCH_RECENT_APPOINTMENT_DATA, RESET_STATE } from "./actions.type";
import { SET_APPOINTMENT_DATA, SET_APPOINTMENT_ERROR, SET_RECENT_APPOINTMENT_DATA, SET_RECENT_APPOINTMENT_ERROR, STATE_RESET } from "./mutations.type";


const initialState = () => {
  return {
    appointmentdata: [],
    appointmenterror: [],
    recentappointmentdata: [],
    recentappointmenterror: []
  }
};

export const state = initialState();

const actions = {

  async [FETCH_APPOINTMENT_DATA](context, slug) {
    return await AppointmentService.getAllAppointments(slug).then(({ data }) => {
      context.commit(SET_APPOINTMENT_DATA, data)
      return data
    }).catch((response) => {
      context.commit(SET_APPOINTMENT_ERROR, (typeof response == Object ? response.data.errorMessage : response))
      return response
    })
  },

  async [FETCH_RECENT_APPOINTMENT_DATA](context, slug) {
    return await AppointmentService.getRecentAppointments(slug).then(({ data }) => {
      context.commit(SET_RECENT_APPOINTMENT_DATA, data)
      return data
    }).catch((response) => {
      context.commit(SET_RECENT_APPOINTMENT_ERROR, (typeof response == Object ? response.data.errorMessage : response))
      return response
    })
  },

  [RESET_STATE]({ commit }) {
    commit(STATE_RESET)
  }

}

const mutations = {

  [SET_APPOINTMENT_DATA](state, data) {
    state.appointmentdata = data
  },
  [SET_APPOINTMENT_ERROR](state, error) {
    state.appointmenterror = error
  },
  [SET_RECENT_APPOINTMENT_DATA](state, data) {
    state.recentappointmentdata = data
  },
  [SET_RECENT_APPOINTMENT_ERROR](state, error) {
    state.recentappointmenterror = error
  },
  [STATE_RESET](state) {
    Object.assign(state, initialState())
  }

}

const getters = {
  appointmentdata(state) {
    return state.appointmentdata;
  },
  recentappointmentdata(state) {
    return state.recentappointmentdata;
  }
}

export default {
  state,
  getters,
  actions,
  mutations
};